import { all, fork } from 'redux-saga/effects';
import { parseSaga } from './parse';
import { loadSaga } from './load';
import { uploadSaga } from './upload';

export default function* assetsSaga() {
  yield all([fork(parseSaga), fork(loadSaga), fork(uploadSaga)]);
}
